/**
 * Affichage table restaurant — le label est libre (Table 5, T4, VIP…).
 * Ne jamais préfixer « Table » automatiquement.
 */

export function formatRestaurantTablePanelTitle(label) {
  const t = String(label ?? '').trim() || '—';
  return `${t} · Service en cours`;
}

export function formatRestaurantTableOptionLabel(label) {
  return String(label ?? '').trim() || '—';
}
